import { useState, FC } from "react"
import { css } from "@emotion/react"
import { Button } from "@ncs/web-legos/components/buttons"

interface ExpandableTextProps {
	text: string
	title: string
	// this is a workaround since useId hooks is not available in React17
	// https://react.dev/reference/react/useId
	useID?: string
	lines?: number
	maxLength?: number
}

export const ExpandableText: FC<ExpandableTextProps> = ({
	text,
	title,
	useID,
	lines = 2,
	maxLength = 100,
}) => {
	const [expanded, setExpanded] = useState(false)
	const isLong = text.length > maxLength

	return (
		<>
			<h3 css={titleStyle}>{title}</h3>
			<p id={useID} css={styleDescription(expanded, lines)}>
				{text}
			</p>

			{isLong && (
				<Button
					onClick={() => setExpanded((prev) => !prev)}
					aria-expanded={expanded}
					aria-controls={useID}
					aria-label={expanded ? undefined : "More Info"}
				>
					<div css={styleMoreInfoBtn}>{expanded ? null : "More Info"}</div>
				</Button>
			)}
		</>
	)
}

export const styleMoreInfoBtn = (theme: any) => css`
	font-weight: 700;
	color: ${theme.palette.colors.blue500};
	font-size: 1rem;
	cursor: pointer;
	line-height: 1.5rem;
	margin-top: 1rem;
`

export const titleStyle = css`
	font-weight: 700;
	color: #393939;
	font-size: 1rem;
	margin-bottom: 0.5rem;
`

export const styleDescription = (expanded: boolean, lines: number) => css`
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: ${expanded ? "unset" : lines};
	white-space: normal;
	max-width: 40rem;
`
